<template>
  <div class="flex flex-wrap items-center gap-2" :class="textSizeClass">
    <div v-if="sellers.length > 0" class="flex -space-x-1">
      <span
        v-for="seller in visibleSellers"
        :key="seller.id"
        class="inline-flex items-center justify-center rounded-full bg-purple-200 font-semibold text-purple-800 ring-2 ring-white"
        :class="avatarSizeClass"
      >
        {{ getInitials(seller.name) }}
      </span>
      <span
        v-if="overflowCount > 0"
        class="inline-flex items-center justify-center rounded-full bg-gray-200 font-semibold text-gray-600 ring-2 ring-white"
        :class="avatarSizeClass"
      >
        +{{ overflowCount }}
      </span>
    </div>

    <slot name="follow-up" />
  </div>
</template>

<script>
const MAX_VISIBLE = 3;

export default {
  name: "SellerAvatarGroup",
  props: {
    sellers: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },
  computed: {
    visibleSellers() {
      return this.sellers.slice(0, MAX_VISIBLE);
    },
    overflowCount() {
      return Math.max(0, this.sellers.length - MAX_VISIBLE);
    },
    avatarSizeClass() {
      return this.size === "sm" ? "h-6 w-6" : "h-7 w-7 text-xs";
    },
    textSizeClass() {
      return this.size === "sm" ? "text-xs" : "text-sm";
    },
  },
  methods: {
    getInitials(name) {
      const parts = (name || "").trim().split(/\s+/).filter(Boolean);
      if (parts.length === 0) return "?";
      return parts
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
  },
};
</script>
